import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { CallInsights } from '../reports/CallInsights';
import type { CallsInsightHubState } from '../CallsInsightHub/useCallsInsightHub';
const ease = [0.23, 1, 0.32, 1] as const;
export function InsightsDialog({
  hub,
  onClose
}: {
  hub: CallsInsightHubState;
  onClose: () => void;
}) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return <div className="fixed inset-0 z-40 flex items-start justify-center p-4 pt-24" data-id="element-287" data-mp="3ogfy3i6x88ny">
      <motion.div className="absolute inset-0 bg-accent/25 backdrop-blur-[2px]" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease
    }} onClick={onClose} aria-hidden data-id="element-288" data-mp="yr458tikf2le" />
      <motion.div role="dialog" aria-modal="true" aria-labelledby="insights-heading" className="relative w-full max-w-md" initial={{
      opacity: 0,
      scale: 0.96,
      y: 8
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.96,
      y: 8
    }} transition={{
      duration: 0.22,
      ease
    }} data-id="element-289" data-mp="3eb721gmpnc2v">
        <CallInsights hub={hub} data-id="element-290" data-mp="2zfhcj8ibggte" />
        <button ref={closeRef} type="button" onClick={onClose} aria-label="Close insights" className="absolute right-4 top-4 rounded-lg p-1.5 text-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-291" data-mp="2zfr0kqjswdwg">
          <XIcon className="h-4 w-4" data-id="element-292" data-mp="2gm3o7m93z8mr" />
        </button>
      </motion.div>
    </div>;
}